import Redactor from '../../redactor.esm.min.js'
import { registerToolbarButton } from '../registerButton'

class MpClearFormatPlugin {
    static defaultLang = {
        en: {
            mpClearFormat: {
                title: 'Clear all styles'
            }
        }
    }

    constructor(app, options = {}) {
        this.app = app
        this.options = options
        this.buttonIcon = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.5654 8.00043V6.435H6.43555V8.00043C6.43534 8.46141 6.06161 8.83539 5.60059 8.83539C5.13956 8.83539 4.76584 8.46141 4.76562 8.00043V5.60004C4.76562 5.13888 5.13943 4.76508 5.60059 4.76508H18.4004C18.8615 4.76508 19.2354 5.13888 19.2354 5.60004V8.00043C19.2351 8.46141 18.8614 8.83539 18.4004 8.83539C17.9395 8.83528 17.5656 8.46134 17.5654 8.00043Z" fill="black"/>
<path d="M11.1992 17.5651C11.6604 17.5651 12.0342 17.9389 12.0342 18.4C12.0342 18.8612 11.6604 19.235 11.1992 19.235H6.39941C5.93826 19.235 5.56445 18.8612 5.56445 18.4C5.56445 17.9389 5.93826 17.5651 6.39941 17.5651H11.1992Z" fill="black"/>
<path d="M12.7998 5.60004L8.7998 18.4Z" fill="black"/>
<path d="M12.0031 5.35104C12.1406 4.91088 12.6088 4.66564 13.049 4.80319C13.4891 4.94075 13.7344 5.40893 13.5968 5.84909L9.59683 18.6489C9.45928 19.0891 8.9911 19.3343 8.55093 19.1967C8.11079 19.0592 7.86553 18.591 8.00308 18.1508L12.0031 5.35104Z" fill="black"/>
<path d="M14.4004 14.4L18.4004 18.4Z" fill="black"/>
<path d="M13.81 13.8092C14.1361 13.4831 14.6655 13.4831 14.9916 13.8092L18.9916 17.8092C19.3177 18.1353 19.3177 18.6648 18.9916 18.9908C18.6655 19.3169 18.1361 19.3169 17.81 18.9908L13.81 14.9908C13.4839 14.6648 13.4839 14.1353 13.81 13.8092Z" fill="black"/>
<path d="M18.4004 14.4L14.4004 18.4Z" fill="black"/>
<path d="M17.81 13.8092C18.1361 13.4831 18.6655 13.4831 18.9916 13.8092C19.3177 14.1353 19.3177 14.6648 18.9916 14.9908L14.9916 18.9908C14.6655 19.3169 14.1361 19.3169 13.81 18.9908C13.4839 18.6648 13.4839 18.1353 13.81 17.8092L17.81 13.8092Z" fill="black"/>
</svg>`
    }

    start() {
        registerToolbarButton(this.app, 'mpClearFormat', this._createToolbarButton())
    }

    _createToolbarButton() {
        return {
            title: this.app.getLang('mpClearFormat.title'),
            html: `<span class="rx-button-icon">${this.buttonIcon}</span>`,
            classname: 'mp-clear-format-button',
            position: { before: 'moreinline' },
            command: 'mpClearFormat.clear'
        }
    }

    clear() {
        this.app.inline.removeFormat()
    }
}

Redactor.addPlugin('mpClearFormat', MpClearFormatPlugin)
